<template>
    <div>
        <mt-header title="保單信息"></mt-header>
        <h2 style="color: black;padding: 10px;">客戶 (持有人) : {{ownerName}} {{policy.policyNo}}</h2>
        <div style="padding: 15px;
    font-size: 16px;">
            <div style="margin-bottom: 10px;">保單編號 : {{policy.policyNo}}</div>
            <div style="margin-bottom: 10px;">被保人 : {{insuredName}}</div>
            <div style="margin-bottom: 10px;">持有人 : {{ownerName}}</div>
            <div style="margin-bottom: 10px;">保單狀態 : {{statusStr}}</div>
            <div style="margin-bottom: 10px;">{{statusDesc}}</div>
            <div style="margin-bottom: 10px;">備註:</div>
            <div v-for="item in policy.policyRemarkList">
                <div style="margin-bottom: 5px;">建立日期 : <span>{{item.createDate*1000| date('%Y-%m-%d')}}</span></div>
                <div style="margin-bottom: 5px;">內容 : <span>{{item.content}}</span></div>
                <div style="margin-bottom: 30px;"> 完成日期 : <span v-if="item.solvedDate!=null">{{item.solvedDate*1000| date('%Y-%m-%d')}}</span></div>
            </div>
            <div>謝謝 !</div>

        </div>

    </div>
</template>

<script>
    import "mint-ui/lib/style.css";
    import { Header } from 'mint-ui';
    import {wechatPolicyInfo} from '../../api/api'

    export default {
        data() {
            //驗證登錄名字
            return {
                policy:{},
                renewalNoticeList:[],
                policyId:null,
                toDate:null,
                insuredName:"",
                ownerName:"",
                statusOption:[
                    //狀態, 0:處理中, 1:存檔, 2: 終止申請, 3. 冷靜期退保, 4: 生效, 5:轉出保單, 6: 保單失效
                    {label:'處理中',value:0},{label:'存檔',value:1},{label:'終止申請',value:2},{label:'冷靜期退保',value:3},
                    {label:'生效',value:4},{label:'轉出保單',value:5},{label:'保單失效',value:6},{label:'擱置',value:7}
                    ,{label:'拒保',value:8},{label:'廢除',value:9}
                ],
                statusStr:"",
                statusDesc:""
            }
        },
        methods: {
            queryWechatPolicyInfo(){
                    let params={policyId:this.policyId}
                    return wechatPolicyInfo(params).then(res=>{
                        if(res.errcode==200){
                            this.policy=res.data;
                            console.log(this.policy);
                            this.statusStr = this.statusOption.find(v=>v.value==this.policy.status).label;
                            if(this.policy.status==0){
                                this.statusDesc = '已收到計劃資料，現正處理中，如有任何問題，行政部會加以聯繫。';
                            }else if(this.policy.status==2){
                                this.statusDesc = '保單已取消申請。';
                            }else if(this.policy.status==3){
                                this.statusDesc = '已收到客戶行使冷靜期退保權益指示，正進行處理，如有任何問題，行政及會計部同事會再加以聯絡。'
                            }else if(this.policy.status==4){
                                this.statusDesc = '保單經已審批，請跟進並確認客戶已簽收相關文件'
                            }else if(this.policy.status==6){
                                this.statusDesc = '保單經已或快將失效，如有任何問題，請盡快與市場或行政部同事聯絡。'
                            }

                            //已收到計劃資料，現正處理中，如有任何問題，行政部會加以聯繫。
                            this.policy.customerList.forEach(v=>{
                                if(v.insured==1){
                                    this.insuredName = v.customerOption[0].nameEng +" " + v.customerOption[0].nameChi;
                                }
                                if(v.applicant==1){
                                    this.ownerName = v.customerOption[0].nameEng +" " + v.customerOption[0].nameChi;
                                }
                            })
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("queryWechatPolicyInfo Error");
                    });
                }
        },
        mounted() {
            this.policyId=this.$route.query.id;
            this.queryWechatPolicyInfo();
        },
        computed: {

        },
        activated(){

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/wechat/PolicyInfo.vue